var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',[_c('span',[_vm._v("hii")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }